"use strict";

(function () {

    ready( () => {

        let baguetteBox = require('baguettebox.js'),
            bbOverlay,
            closeButton,
            Isotope = require('isotope-layout'),
            elem = document.querySelector('.portfolio-grid'),
            filters = document.querySelectorAll('.portfolio-nav a'),
            filterSelector = document.querySelector('.portfolio-nav-selector'),
            galleryLinks = document.querySelectorAll('.gallery a'),
            imagesLoaded = require('imagesloaded'),
            overlay = document.querySelector('.overlay-text'),
            portfolioItems = document.querySelectorAll('.portfolio-item'),
            selectorSpeed = 2,
            selectorTarget = 0,
            iso = new Isotope( elem, {
            // options
            itemSelector: '.portfolio-item',
                layoutMode: 'masonry',
                masonry: {
                    // use element for option
                    columnWidth: '.portfolio-item'
                }
            });

        initPortfolio();
        imagesLoaded(".portfolio-grid", refreshLayout);

        function initPortfolio() {
            window.addEventListener("resize", refreshSelectorPos);
            document.addEventListener("keyup", handleKeyUp);
            for (let i = 0; i < filters.length; i++) {
                filters[i].addEventListener("click", filterGrid);
            }
            for (let i = 0; i < portfolioItems.length; i++) {
                let itemID = portfolioItems[i].id;
                baguetteBox.run("#" + itemID + " .gallery");
                portfolioItems[i].addEventListener("mouseover", addAnimationClass);
            }
            for (let i = 0; i < galleryLinks.length; i++) {
                galleryLinks[i].addEventListener("click", onGalleryOpen);
            }
            closeButton = document.querySelector("#close-button");
            bbOverlay = document.getElementById("baguetteBox-overlay");
            setTimeout(addCloseListener, 300);
        }

        function refreshLayout() {
            iso.layout();
        }

        function handleKeyUp(event) {
            if (event.keyCode === 27) {
                hideOverlay();
            }
        }

        // This is a hacky way to prevent keyframe animations from firing on pageload
        function addAnimationClass(event) {
            let item = event.currentTarget;
            if (item.classList.contains("animated") === false) {
                item.classList.add("animated");
            }
        }

        function removeAnimationClass() {
            let animatedElements = document.querySelectorAll(".animated");
            for (let elem of animatedElements) {
                elem.classList.remove("animated");
            }
        }

        function addCloseListener() {
            closeButton.addEventListener("click", hideOverlay);
            bbOverlay.addEventListener("click", hideOverlay);
        }

        function onGalleryOpen(event) {
            let item = event.currentTarget,
                overlayTitle = item.dataset.title;
            showOverlay(overlayTitle);
        }

        function showOverlay(overlayTitle) {
            overlay.innerHTML = overlayTitle;
            overlay.classList.add("active");
        }

        function hideOverlay() {
            overlay.classList.remove("active");
        }

        function filterGrid(event) {
            let filter = event.target,
                cat = filter.dataset.cat;
            iso.arrange({
                filter: function( itemElem) {
                    return hasClass(itemElem, cat);
                }
            });
            document.querySelector('.portfolio-nav .active').classList.remove("active");
            filter.classList.add("active");
            filterSelector.classList.add("clicked");
            removeAnimationClass();
            setSelectorPos(event);
            setTimeout(function() { filterSelector.classList.remove("clicked"); }, 500);
        }

        function setSelectorPos(event) {
            let filterElem = event.target,
                leftPos = filterElem.offsetLeft;
            filterSelector.style.left = leftPos + "px";
        }

        function refreshSelectorPos() {
            let leftPos = document.querySelector('.portfolio-nav .active').offsetLeft;
            filterSelector.style.left = leftPos + "px";
        }

        function hasClass(elem, className) {
            if (elem.classList)
              return elem.classList.contains(className);
            else
              return new RegExp('(^| )' + className + '( |$)', 'gi').test(elem.className);
        }

        function getClosest( elem, selector ) {

            // Element.matches() polyfill
            if (!Element.prototype.matches) {
                Element.prototype.matches =
                    Element.prototype.matchesSelector ||
                    Element.prototype.mozMatchesSelector ||
                    Element.prototype.msMatchesSelector ||
                    Element.prototype.oMatchesSelector ||
                    Element.prototype.webkitMatchesSelector ||
                    function(s) {
                        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                            i = matches.length;
                        while (--i >= 0 && matches.item(i) !== this) {}
                        return i > -1;
                    };
            }

            // Get closest match
            for (; elem && elem !== document; elem = elem.parentNode) {
                if ( elem.matches( selector ) ) return elem;
            }

            return null;

        }

    });

    function ready(fn) {
      if (document.readyState != 'loading'){
        fn();
      } else {
        document.addEventListener('DOMContentLoaded', fn);
      }
    }

})();


// WEBPACK FOOTER //
// ./js/app.js